<template>
  <div class="dashboard-grid">
    <div
      v-for="(chart, index) in charts"
      :key="index"
      class="dashboard-grid-item"
    >
      <div v-if="chart?.loading" class="chart-slot-state loading">
        <v-progress-circular indeterminate color="primary" size="28" width="2"></v-progress-circular>
        <p>Loading plot...</p>
      </div>
      <div v-else-if="chart?.error" class="chart-slot-state error">
        <v-icon size="22" color="#C24141">mdi-alert-circle-outline</v-icon>
        <p class="slot-error-title">{{ chart.title || `Plot ${index + 1}` }}</p>
        <p class="slot-error-msg">{{ chart.error }}</p>
      </div>
      <ChartCard
        v-else-if="chart"
        :chart-title="chart.title"
        :chart-data="chart"
        :chart-index="index"
        :is-selected="selectedChartIndex === index"
        @chart-selected="handleChartSelected"
      />
      <div v-else class="empty-chart-slot" @click="handleEmptySlotClick" :title="'Click to open chat and create a new plot'">
        <p class="empty-slot-text">Add/create a new plot here from the chat.</p>
      </div>
    </div>
  </div>
</template>

<script>
import ChartCard from "./ChartCard.vue";

export default {
  name: "DashboardGrid",
  components: {
    ChartCard,
  },
  props: {
    charts: {
      type: Array,
      required: true,
      default: () => [],
    },
    selectedChartIndex: {
      type: Number,
      default: null,
    },
  },
  methods: {
    handleEmptySlotClick() {
      this.$emit("empty-slot-click");
    },
    handleChartSelected(index) {
      this.$emit("chart-selected", index);
    },
  },
};
</script>

<style scoped>
@import '../../assets/Styling/agenticDashboard/dashboardGrid.css';
</style>
